module.exports = __webpack_public_path__ + "static/media/1-star.ab5d49ef.png";